exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".nav>li>a.gongqi_tabpage{padding:2px 15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/styles/FormItemTabStyle.css
// module id = 306
// module chunks = 1 2 3 4 5 7